import React from 'react'

function AboutUs() {
  return (
    <div style={{color:'white'}}>AboutUs</div>
  )
}

export default AboutUs